import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      className="admin-back-btn"
      onClick={() => navigate("/admin/dashboard")}
      data-testid="admin-back-btn"
    >
      <ArrowLeft size={18} />
      Back to Dashboard
    </Button>
  );
}
